import React from 'react';
import {
  Dialog,
  DialogContent,
  DialogActions,
  Button,
  TableContainer,
  Paper,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
} from '@mui/material';
import {
  DialogHeader,
  PaginationControls,
  ExecutionTableRow,
  useExecutionHistory,
} from './ExecutionHistoryDialogComponents';

const ExecutionHistoryDialog = ({
  open,
  onClose,
  executions,
  onSelectExecution,
  templateId,
}) => {
  const {
    expandedRows,
    feedbackMap,
    page,
    rowsPerPage,
    sortBy,
    sortOrder,
    sortedAndPaginatedExecutions,
    toggleRowExpansion,
    handleChangePage,
    handleChangeRowsPerPage,
    handleSortChange,
  } = useExecutionHistory(open, templateId, executions);

  const handleViewDetails = executionId => {
    onSelectExecution(executionId);
    onClose();
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xl" fullWidth>
      <DialogHeader onClose={onClose} />
      <DialogContent>
        <PaginationControls
          page={page}
          rowsPerPage={rowsPerPage}
          totalExecutions={executions?.length || 0}
          sortBy={sortBy}
          sortOrder={sortOrder}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
          onSortChange={handleSortChange}
        />

        <TableContainer component={Paper}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>ID</TableCell>
                <TableCell>Status</TableCell>
                <TableCell>Created</TableCell>
                <TableCell>Execution Time</TableCell>
                <TableCell>Model</TableCell>
                <TableCell>Provider</TableCell>
                <TableCell>Cost</TableCell>
                <TableCell>Actions</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {sortedAndPaginatedExecutions.map(execution => (
                <ExecutionTableRow
                  key={execution.id}
                  execution={execution}
                  isExpanded={expandedRows.has(execution.id)}
                  hasFeedback={!!feedbackMap[execution.id]}
                  onToggleExpansion={toggleRowExpansion}
                  onViewDetails={handleViewDetails}
                  feedback={feedbackMap[execution.id]}
                />
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Close</Button>
      </DialogActions>
    </Dialog>
  );
};

export default ExecutionHistoryDialog;
